import React, { useState } from 'react'
import { createFeedback as createFeedbackAPI } from '../utils/api.js'

export default function Feedback({ faqId, show, onClose, onFeedback }) {
  const [comment, setComment] = useState('')

  const handleSubmit = async () => {
    try {
      await createFeedbackAPI(faqId, { rating: 0, comment })
      onFeedback()
      setComment('')
      onClose()
    } catch (err) {
      console.error(err)
      alert('Failed to submit feedback')
    }
  }

  if (!show) return null

  return (
    <>
      <div className="feedback-modal_backdrop modal-backdrop fade show" />
      <div className="feedback-modal modal fade show" tabIndex="-1" style={{ display: 'block' }}>
        <div className="feedback-modal_dialog modal-dialog">
          <div className="feedback-modal_content modal-content">
            <div className="feedback-modal_header modal-header">
              <h5 className="feedback-modal_title modal-title">Optional Feedback</h5>
              <button type="button" className="feedback-modal_close-btn btn-close" onClick={onClose} />
            </div>
            <div className="feedback-modal_body modal-body">
              <textarea
                className="feedback-modal_textarea form-control"
                rows={3}
                value={comment}
                onChange={e => setComment(e.target.value)}
                placeholder="Your comment (optional)"
              />
            </div>
            <div className="feedback-modal_footer modal-footer">
              <button
                type="button"
                className="feedback-modal_cancel-btn btn btn-secondary"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="feedback-modal_submit-btn btn btn-primary"
                onClick={handleSubmit}
              >
                Submit Feedback
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}